import React from "react";
import CompletedPromoLayout from "../../layouts/CompletedPromoLayout";

export default function CompletedPromo() {
    return (
        <div className="w-full h-full">
            <CompletedPromoLayout />
        </div>
    );
}
